<tlk-card class="rx-intuitive-scan-surgical-guide-card">
	<span tlkCardHeader>{{ procedureTitle$ | async }}</span>
	<div tlkCardContent>
		<div class="rx-intuitive-scan-surgical-guide-content">
			<!-- Type control section -->
			<div class="rx-intuitive-scan-surgical-guide-type-control">
				<rx-procedure-type-control [id]="'scan-surgical-guide-type'"></rx-procedure-type-control>
			</div>
		</div>
	</div>
</tlk-card>
